import type { RouteRecordRaw } from 'vue-router';

export default <RouteRecordRaw[]>[
  {
    path: '/',
    name: 'logged-out',
    component: () => import('./views/LoggedOutView.vue'),
    meta: {
      isPublic: true,
    },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('./views/LoginView.view.vue'),
    meta: {
      isPublic: true,
    },
  },
  {
    path: '/2fa/challenge',
    name: '2fa-challenge',
    component: () => import('./views/TwoFactorChallenge.view.vue'),
    meta: {
      isPublic: true,
      isPending2FA: true,
    },
  },
  {
    path: '/2fa/readiness',
    name: '2fa-readiness',
    component: () => import('./views/TwoFactorReadiness.view.vue'),
    meta: {
      isPublic: true,
      isPending2FAReadiness: true,
    },
  },
  {
    path: '/password-expired',
    name: 'password-expired',
    component: () => import('./views/PasswordExpired.view.vue'),
    meta: {
      isPublic: true,
      isPendingPasswordExpired: true,
    },
  },
  {
    path: '/email-verification',
    name: 'email-verification',
    component: () => import('./views/EmailVerification.view.vue'),
    meta: {
      isPublic: true,
    },
  },
  {
    path: '/register',
    redirect: '/login',
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('./views/ForgotPassword.view.vue'),
    meta: {
      isPublic: true,
    },
  },
  {
    path: '/password/reset/',
    name: 'password-reset-no-token',
    meta: {
      isPublic: true,
    },
    component: () => import('./views/PasswordReset.view.vue'),
  },
  {
    path: '/password/reset/:token',
    name: 'password-reset',
    meta: {
      isPublic: true,
    },
    component: () => import('./views/PasswordReset.view.vue'),
  },
  {
    path: '/shelter/access-denied',
    name: 'access-denied',
    component: () => import('./views/AccessDenied.view.vue'),
  },
];
